var Extensions = {
    register: $.proxy(function () {
        this.string();
    }, Extensions),

    string: function () {
        // Capitalize the first letter in a string
        String.prototype.capitalize = function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        };
    },
};

module.exports = Extensions;
